import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { getFormattedDate } from "utils/functions";
import { Link } from "react-router-dom";
import CategoryTag from "core/tags/category-tag/CategoryTag";
import { TAG_TYPES } from "constants/constants";
import PropTypes from "prop-types";
import { getEntityName, getEntitySlug } from "utils/helper";

const SubcontractorsSubcontractingCompany = ({
  list,
  subcontractors,
  lang,
  usersByIds,
  userScope,
  setSlugSearched,
  namesByFilters,
}) => {
  const header = [
    {
      label: {
        key: "subcontractor",
        value: (
          <FormattedMessage
            id="subcontractor"
            defaultMessage={"Sous-traitant"}
          />
        ),
      },
      icon: "user",
      minWidth: "22.3%",
    },
    {
      label: {
        key: "start",
        value: <FormattedMessage id="start" defaultMessage={"Début"} />,
      },
      icon: "calendar",
      minWidth: "7.9%",
    },
    {
      label: {
        key: "end",
        value: <FormattedMessage id="end" defaultMessage={"Fin"} />,
      },
      icon: "calendar",
      minWidth: "7.9%",
    },
    {
      label: {
        key: "manager",
        value: <FormattedMessage id="manager" defaultMessage={"Manager"} />,
      },
      icon: "user",
      minWidth: "13.85%",
    },
  ];

  const getFormattedList = (list, subcontractors) =>
    list.map((elm) => {
      const subcontractor = _.find(
        namesByFilters,
        (person) => person.id === elm.subcontractor_id
      );

      const manager = _.find(
        namesByFilters,
        (person) => person.id === subcontractor?.manager_id
      );
      const subcontractorFullName = getEntityName(
        elm.subcontractor_id,
        namesByFilters
      );

      const managerFullName = getEntityName(
        subcontractor?.manager_id,
        namesByFilters
      );
      return {
        subcontractor_id: (
          <Link
            to={`/${userScope}/subcontractor/${getEntitySlug(
              elm?.subcontractor_id,
              namesByFilters
            )}`}
            onClick={() => {
              setSlugSearched(
                getEntitySlug(elm?.subcontractor_id, namesByFilters)
              );
            }}
          >
            {subcontractorFullName}
          </Link>
        ),
        establishment_date: getFormattedDate(elm?.establishment_date, lang),
        establishment_date_end: getFormattedDate(
          elm?.establishment_date_end,
          lang
        ),
        manager_id: (
          <CategoryTag
            key={1}
            type={TAG_TYPES.PEOPLE}
            label={managerFullName || ""}
            showing={true}
            many={false}
            deleteOption={false}
            linkValue={subcontractor?.manager_id}
          />
        ),
      };
    });

  return (
    <div className="section">
      <ScrollToTop />
      <div className="display-flex">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="subcontractors"
              defaultMessage="subcontractors"
            />
          }
        />
      </div>
      <div>
        <Table
          id="subcontractors"
          header={header}
          content={getFormattedList(list, subcontractors) || []}
        />
      </div>
    </div>
  );
};

export default SubcontractorsSubcontractingCompany;

SubcontractorsSubcontractingCompany.propTypes = {
  list: PropTypes.array,
  subcontractors: PropTypes.array,
  lang: PropTypes.string,
  usersByIds: PropTypes.array,
  userScope: PropTypes.string,
  setSlugSearched: PropTypes.func,
  namesByFilters: PropTypes.array,
};
